// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__2Ut5d","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__3gJw_"};